import { HelpfulVideo } from 'app/components/HelpfulVideo'
import { Container } from 'app/containers/Container'
import { Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { getBrandHelpers, getBrandInfo } from 'config'
import { IHelpfulVideo } from 'config/interfaces'
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Alert, Button, ButtonGroup, Col, FormGroup, Modal, ModalBody, Panel, Row } from 'react-bootstrap'
import { default as InfiniteCalendar, ReactInfiniteCalendarProps } from 'react-infinite-calendar'
import { Link } from 'react-router-dom'

interface IDashboardState {
  nowShowingVideo: IHelpfulVideo
  showIntroduction: boolean
  mustShowDashboard: boolean
  profile: Profile
}

class Dashboard extends Container<{}, IDashboardState> {
  state = {
    nowShowingVideo: undefined,
    showIntroduction: false,
    mustShowDashboard: false,
    profile: null
  }

  private pipelineInstances = this.getCustomerPipelineInstances()

  componentWillMount() {
    this.Actions.Nav.showDefaultNavRoutes()
    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.getNative('info')
      if (profile) {
        const showIntroduction = profile.showIntroduction
        this.setState({ showIntroduction, profile })
      }
    })
  }

  onGetStartedClick() {
    this.setState({ mustShowDashboard: true })
  }

  onShowIntroChange() {
    const showIntroduction = !this.state.showIntroduction
    this.setState({ showIntroduction, mustShowDashboard: false })
    // tslint:disable-next-line:no-console
    console.log('showIntroduction is now: ' + showIntroduction)
    this.state.profile.showIntroduction = showIntroduction
    this.debounceStoreProfile(this.state.profile)
  }

  renderHelpfulVideoLinks() {
    if (0 === getBrandInfo().dashboardVideos.length) { return null }
    return <article>
      <h4>Helpful Videos</h4>
      <p>
        {_.map(getBrandInfo().dashboardVideos, (v, index) =>
          <a key={index} className="modal-trigger" href="javascript:void(0)"
            onClick={() => this.setState({ nowShowingVideo: v })}>
            <i className="fa fa-fw fa-youtube-play"></i>{v.caption}
          </a>
        )}
      </p>
    </article>
  }

  renderVideo(url: string, width: number, height: number) {
    const html5Markup = <iframe src={url}
      style={{ position: 'absolute', width: '100%', height: '100%', left: 0 }}
      width={width} height={height}
      frameBorder={0}
      allowFullScreen />
    const IEMarkup = <object width={width} height={height} data={url}></object>
    return utils.isInternetExplorer() ? IEMarkup : html5Markup
  }

  render() {
    const today = new Date()

    const dashboardPipelines = this.pipelineInstances
      .filter((p) => !p.hiddenInDashboard)

    return (
      <section className="container-main">
        <h1>What section would you like to start?</h1>

        <p className="lead">
          Keep in mind, whatever you start with, you can pause at anytime and finish later! When you've completed a section you can choose to continue to the next section, or go see your progress updated in the <a href="#/Results/retirement_summary"><b>Retirement Summary</b></a> page.
        </p>

        <Row>
          {dashboardPipelines.map((pipelineInstance) => (
            <Col md={3} key={pipelineInstance.path}>
              <Link to={pipelineInstance.path}>
                <div className="card">
                  <img src={pipelineInstance.thumbnailUrl} className="img-responsive" />
                  <header className="card-title">
                    {pipelineInstance.name}
                  </header>
                  <Button bsStyle="primary" block>
                    Get Started
                  </Button>
                </div>
              </Link>
            </Col>
          ))}
        </Row>

        {this.renderHelpfulVideoLinks()}

        <p className="lead">
          There is important information such as your name and date-of-birth that is kept in your <a href="#/profile"><b>profile</b></a> page. Please make sure that it is correct.
        </p>

        <HelpfulVideo info={this.state.nowShowingVideo} onClose={() => this.setState({ nowShowingVideo: undefined })} />

      </section>

    )
  }
}

export {
  Dashboard
}



// WEBPACK FOOTER //
// ./src/app/containers/Dashboard/index.tsx